import React from 'react';

import { Flex, Heading } from '@rover/kibble/core';
import { HeadingSizes } from '@rover/kibble/tokens/build/rover/es6/theme';
import type { Behavior } from '@rover/rsdk/src/apiClient/latest/model/behavior';
import type { BehaviorCustom } from '@rover/rsdk/src/apiClient/latest/model/behaviorCustom';
import type { Skill } from '@rover/rsdk/src/apiClient/latest/model/skill';
import type { SkillCustom } from '@rover/rsdk/src/apiClient/latest/model/skillCustom';

import { TextBadge } from './TextBadge';

type TextBadgeSectionProps = {
  heading: string;
  headingSize?: HeadingSizes;
  items: Behavior[] | Skill[];
  itemsCustom: BehaviorCustom[] | SkillCustom[];
  isTrainerProfileReordering?: boolean;
};

const TextBadgeSection: React.FC<TextBadgeSectionProps> = ({
  heading,
  headingSize = '200',
  items,
  itemsCustom,
  isTrainerProfileReordering = false,
}) => (
  <Flex flexDirection="column" gap={isTrainerProfileReordering ? '0x' : '2x'}>
    <Heading size={headingSize} mb="2x" mt="4x">
      {heading}
    </Heading>
    <Flex gap="2x" flexWrap="wrap" py="2x">
      {items.map((item) => (
        <TextBadge key={item.slug} isTrainerProfileReordering={isTrainerProfileReordering}>
          {item.text}
        </TextBadge>
      ))}
      {itemsCustom.map((itemCustom) => (
        <TextBadge key={itemCustom.opk} isTrainerProfileReordering={isTrainerProfileReordering}>
          {itemCustom.text}
        </TextBadge>
      ))}
    </Flex>
  </Flex>
);

export default TextBadgeSection;
